import { Injectable } from "@angular/core";
import { INotification, NotificationType } from "../models/core/notification.model";
import { Observable, Subject } from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private notificationSource = new Subject<INotification>();

  getMessageChanges(): Observable<INotification> {
    return this.notificationSource.asObservable();
  }

  addMessage(message: string, type: NotificationType, autoDismiss = false){    
    var notification: INotification = {
      id:  Date.now().toString(),
      text: message, 
      type: type,
      autoDismiss: autoDismiss
    }
    this.notificationSource.next(notification);
  }
  
  sendInfoMessage(message: string) {
    this.addMessage(message, NotificationType.Info, true);
  }

  sendSuccessMessage(message: string) {
    this.addMessage(message, NotificationType.Success, true);
  }

  sendFailureMessage(message: string) {
    this.addMessage(message, NotificationType.Error);
  }

  sendWarningMessage(message: string) {
    this.addMessage(message, NotificationType.Warning);
  }  
}